import React, { useState } from 'react';

import Icon from '../../../components/AppIcon';

const ExportReports = ({ userId, dateRange }) => {
  const [exporting, setExporting] = useState(false);
  const [success, setSuccess] = useState('');

  const handleExport = async (format) => {
    setExporting(true);
    setSuccess('');
    try {
      // Simulate export
      await new Promise(resolve => setTimeout(resolve, 1000));
      setSuccess(`Report exported as ${format?.toUpperCase()} successfully!`);
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      console.error('Export error:', err);
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <h3 className="text-lg font-semibold text-foreground mb-4">Export Reports</h3>
      {success && (
        <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-4 flex items-center space-x-2">
          <Icon name="CheckCircle" size={16} className="text-green-500" />
          <p className="text-green-700 text-sm">{success}</p>
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {['csv', 'pdf', 'xlsx']?.map(format => (
          <button
            key={format}
            onClick={() => handleExport(format)}
            disabled={exporting}
            className="flex flex-col items-center p-6 border border-border rounded-lg hover:bg-muted/50 transition-colors disabled:opacity-50"
          >
            <Icon name={format === 'pdf' ? 'FileText' : 'Download'} size={32} className="text-primary mb-3" />
            <span className="font-medium text-foreground">{format?.toUpperCase()}</span>
            <span className="text-xs text-muted-foreground mt-1">Export as {format?.toUpperCase()}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ExportReports;